import {MatCardModule} from '@angular/material/card';
import {Component} from '@angular/core';

@Component({
    templateUrl: './bootshaus-page.component.html',
    styleUrls: ['./bootshaus-page.component.scss'],
    imports: [MatCardModule]
})
export class BootshausPageComponent {}
